import { Avatar, Typography } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useBoundStore } from "store";
import "./ProfilePictureUpload.scss";

export const ProfilePictureUpload = () => {
  const user = useBoundStore((state) => state.user);

  return (
    <div className="profile-picture-upload-container">
      <Avatar
        size={80}
        src={user?.picture || undefined}
        icon={!user?.picture ? <UserOutlined /> : undefined}
        className="profile-picture-avatar"
      />
      <Typography.Text type="secondary" style={{ marginLeft: 12 }}>
        Profile picture is managed through your login provider (e.g. Google).
      </Typography.Text>
    </div>
  );
};
